import { render, staticRenderFns } from "./SkinColor.vue?vue&type=template&id=8faef446"
import script from "./SkinColor.vue?vue&type=script&lang=js"
export * from "./SkinColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports